import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';

export default function NavBar(props) {

    const mobile = useMediaQuery('(max-width:960px)');

    return(

        <Button 
            color="default"
            style={{
                fontSize: '12px',
                color: `whitesmoke`,
                minWidth:mobile ? '0px' : '100px'
            }}
        >
            {props.children}
        </Button>
    )
}